<template>
	<div class="transactionreconciliation">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys"></menuBar>
			<a-layout style="overflow: auto;">
				<topBar :fatherMethod="initialize"></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">分账交易列表</div>
					<div class="contentcard">
						<div style="font-size: 14px; font-weight: 700;">交易搜索</div>
						<a-divider dashed style="margin: 10px 0;" />
						<div style="margin-bottom: 20px;">
							<div style="margin-bottom: 20px;">
								<div style="width: 400px;display: inline-block;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;width: 100px;text-align: right;margin-right: 30px;">商品名称</span>
									<a-input placeholder="请输入商品名称" style="width: 260px" v-model="searchlist.sku_title" />
								</div>
								<div style="width: 400px;display: inline-block;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;width: 100px;text-align: right;margin-right: 30px;">订单号</span>
									<a-input placeholder="请输入订单号" style="width: 260px" v-model="searchlist.trade_id" />
								</div>
							</div>
							<div style="margin-bottom: 20px;">
								<div style="width: 400px;display: inline-block;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;width: 100px;text-align: right;margin-right: 30px;">收件人姓名</span>
									<a-input placeholder="请输入收件人姓名" style="width: 260px" v-model="searchlist.receiver_name" />
								</div>
								<div style="width: 400px;display: inline-block;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;width: 100px;text-align: right;margin-right: 30px;">收件人手机号</span>
									<a-input placeholder="请输入收件人手机号" style="width: 260px" v-model="searchlist.receiver_phone" />
								</div>
							</div>
							<div>
								<div style="display: inline-block;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;width: 100px;text-align: right;margin-right: 30px;">时间范围</span>
									<a-range-picker :defaultValue="(!searchlist.start_time&&!searchlist.end_time)?null:[moment(searchlist.start_time, dateFormat),moment(searchlist.end_time, dateFormat)]"
									 @change="onChangeTime" />
								</div>
							</div>
						</div>
						<div style="text-align: center;">
							<a-button type="primary" style="width: 96px;" @click="searchbtn">搜索</a-button>
						</div>
					</div>
					<div class="card-container">
						<a-tabs :defaultActiveKey="liststatus" :activeKey="liststatus" type="card" :tabBarGutter="5" @change="tabChange">
							<a-tab-pane tab="已结算" key="isclear">
								<div style="padding-bottom: 50px;">
									<!-- <div style="display: flow-root;position: relative;margin-bottom: 10px;">
										<a-button type="primary" style="width: 96px;" :disabled="!tradelist.length" @click="exportexcel">导出Excel</a-button>
									</div> -->
									<div>
										<div v-if="issearch" style="text-align: center;background: rgba(0,0,0,0.05);border-radius: 4px;margin-bottom: 20px;padding: 30px 50px;margin: 20px 0;">
											<a-spin />
										</div>
										<div v-if="(!tradelist.length)&&(!issearch)">
											<a-alert message="查询结果为空" banner type="info" />
										</div>
										<div v-if="tradelist.length">
											<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
												<a-col :span="7" style="text-align: center;">商品名称</a-col>
												<a-col :span="3" style="text-align: center;">单价</a-col>
												<a-col :span="2" style="text-align: center;">数量</a-col>
												<a-col :span="2" style="text-align: center;">买家</a-col>
												<a-col :span="4" style="text-align: center;">订单总金额</a-col>
												<a-col :span="6" style="text-align: center;">状态</a-col>
											</a-row>
										</div>
										<div style="color: #666;font-size: 14px;margin-bottom: 20px;" v-for="item in tradelist" :key="item.id">
											<a-row type="flex" justify="space-around" align="middle" style="font-weight: 600;border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;">
												<a-col :span="8" style="text-align: center;">订单号：{{item.trade_number}}</a-col>
												<a-col :span="3" style="text-align: center;">运费：￥{{item.delivery_fee/100}}</a-col>
												<a-col :span="3" style="text-align: center;">订单实付：￥{{item.receipt_price/100}}</a-col>
												<a-col :span="6" style="text-align: center;">创建时间：{{moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}}</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==1">订单提交平台：微信</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==2">订单提交平台：Excel</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;"
											 v-for="order in item.TC_Orders" :key="order.id">
												<a-col :span="2">
													<div style="width: 70px;height: 70px;background-color: #f3f3f5;">
														<img :src="order.sku_cover" width="70" height="70">
													</div>
												</a-col>
												<a-col :span="5" style="text-align: center;position: relative;">
													<div style="text-align: center;">
														<span>{{order.sku_title}}</span><br />
														<span>{{order.sku_properties}}</span>
													</div>
												</a-col>
												<a-col :span="3" style="text-align: center;">
													<s v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price">￥{{order.original_price/100}}</s>
													<br v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price" />
													￥{{order.sku_price/100}}<br>
													一级代理价:￥{{order.first_agency_price/100}}<br>
													二级代理价:￥{{order.second_agency_price/100}}
												</a-col>
												<a-col :span="2" style="text-align: center;">{{order.amount}}</a-col>
												<a-col :span="2" style="text-align: center;position: relative;">
													<a-popover trigger="hover">
														<template slot="content">
															<p>ID:{{item.UIC_User.id}}</p>
														</template>
														<div style="text-align: center;position: relative;">
															<span style="display: inline-block;width: 100%;word-break: break-all;white-space: normal;">{{item.UIC_User.nick_name}}</span>
															<a-tag color="orange" style="margin: 0;">{{item.UIC_User.member_level==1?'会员':item.UIC_User.member_level==2?'VIP会员':item.UIC_User.member_level==3?'钻石会员':'皇冠会员'}}</a-tag>
														</div>
													</a-popover>
												</a-col>
												<a-col :span="4" style="text-align: center;">
													<span>
														总价：￥ {{order.sku_price*order.amount/100}} <br>
														应付：￥ {{order.receipt_price/100}} <br>
														优惠券满减：￥ -{{order.coupon_derate_fee*order.amount/100}}
													</span>
												</a-col>
												<a-col :span="6" style="text-align: center;color: #0099FF;font-weight: 700;">{{status[order.order_status]}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="3" style="">收件人姓名：{{item.receiver_name}}</a-col>
												<a-col :span="6" style="">收件人手机号码：{{item.receiver_phone}}</a-col>
												<a-col :span="15" style="">地址：{{item.receiver_address}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													<div>买家备注：</div>
													<span>{{item.remarks}}</span>
												</a-col>

											</a-row>
											<a-row v-if="(item.first_agency_id||item.second_agency_id)&&!(item.profitsharing_info||item.profitsharing_fail_info)"
											 type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													<span>该订单含有代理分账：</span>
													<a-button @click="profitsharingquery(item)">查询</a-button>
												</a-col>

											</a-row>
											<a-row v-if="item.profitsharing_info||item.profitsharing_fail_info" type="flex" justify="start" align="middle"
											 style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													分账状态提交记录：已提交
												</a-col>
												<a-col :span="10">
													一级代理分账信息：{{get_first_info(item)}}
												</a-col>
												<a-col :span="10">
													二级代理分账信息：{{get_second_info(item)}}
												</a-col>
											</a-row>
											<a-row v-if="item.profitsharing_fail_info" type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													<span>{{item.profitsharing_fail_info}}</span>
												</a-col>
											</a-row>
											<a-row v-if="item.profitsharing_info" type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													实际分账信息：{{item.profitsharing_info.status}}
												</a-col>
												<a-col :span="8" v-for="(receivers,receiversindex) in item.profitsharing_info.receivers" :key="receiversindex">
													<div v-if="receivers.type == 'MERCHANT_ID'">
														{{receivers.description}},金额￥:{{receivers.amount/100}}
													</div>
													<div v-if="receivers.type == 'PERSONAL_OPENID'">
														账户:{{receivers.user_id}},实际分账金额￥:{{receivers.amount/100}}
													</div>
												</a-col>
											</a-row>
										</div>
									</div>
									<div style="float: right;position: relative;bottom: -18px;">
										<a-pagination showSizeChanger @showSizeChange="onShowSizeChange" :current="endpage/pageSize" :pageSize="pageSize" :total="tradesum"
										 showQuickJumper @change="pageChange" />
									</div>
								</div>
							</a-tab-pane>
							<a-tab-pane tab="未结算" key="notclaer">
								<div style="padding-bottom: 50px;">
									<!-- <div style="display: flow-root;position: relative;margin-bottom: 10px;">
										<a-button type="primary" style="width: 96px;" :disabled="!tradelist.length" @click="exportexcel">导出Excel</a-button>
									</div> -->
									<div>
										<div v-if="issearch" style="text-align: center;background: rgba(0,0,0,0.05);border-radius: 4px;margin-bottom: 20px;padding: 30px 50px;margin: 20px 0;">
											<a-spin />
										</div>
										<div v-if="(!tradelist.length)&&(!issearch)">
											<a-alert message="查询结果为空" banner type="info" />
										</div>
										<div v-if="tradelist.length">
											<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
												<a-col :span="7" style="text-align: center;">商品名称</a-col>
												<a-col :span="3" style="text-align: center;">单价</a-col>
												<a-col :span="2" style="text-align: center;">数量</a-col>
												<a-col :span="2" style="text-align: center;">买家</a-col>
												<a-col :span="4" style="text-align: center;">订单总金额</a-col>
												<a-col :span="6" style="text-align: center;">操作</a-col>
											</a-row>
										</div>
										<div style="color: #666;font-size: 14px;margin-bottom: 20px;" v-for="item in tradelist" :key="item.id">
											<a-row type="flex" justify="space-around" align="middle" style="font-weight: 600;border: #e8e8e8 solid 1px;height: 30px;line-height: 30px;">
												<a-col :span="8" style="text-align: center;">订单号：{{item.trade_number}}</a-col>
												<a-col :span="3" style="text-align: center;">运费：￥{{item.delivery_fee/100}}</a-col>
												<a-col :span="3" style="text-align: center;">订单实付：￥{{item.receipt_price/100}}</a-col>
												<a-col :span="6" style="text-align: center;">创建时间：{{moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}}</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==1">订单提交平台：微信</a-col>
												<a-col :span="4" style="text-align: center;" v-if="item.trade_platform==2">订单提交平台：Excel</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;"
											 v-for="order in item.TC_Orders" :key="order.id">
												<a-col :span="2">
													<div style="width: 70px;height: 70px;background-color: #f3f3f5;">
														<img :src="order.sku_cover" width="70" height="70">
													</div>
												</a-col>
												<a-col :span="5" style="text-align: center;position: relative;">
													<div style="text-align: center;">
														<span>{{order.sku_title}}</span><br />
														<span>{{order.sku_properties}}</span>
													</div>
												</a-col>
												<a-col :span="3" style="text-align: center;">
													<s v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price">￥{{order.original_price/100}}</s>
													<br v-if="item.UIC_User.member_level !==1&&order.original_price&&order.original_price>order.sku_price" />
													￥{{order.sku_price/100}}<br>
													一级代理价:￥{{order.first_agency_price/100}}<br>
													二级代理价:￥{{order.second_agency_price/100}}
												</a-col>
												<a-col :span="2" style="text-align: center;">{{order.amount}}</a-col>
												<a-col :span="2" style="text-align: center;position: relative;">
													<a-popover trigger="hover">
														<template slot="content">
															<p>ID:{{item.UIC_User.id}}</p>
														</template>
														<div style="text-align: center;position: relative;">
															<span style="display: inline-block;width: 100%;word-break: break-all;white-space: normal;">{{item.UIC_User.nick_name}}</span>
															<a-tag color="orange" style="margin: 0;">{{item.UIC_User.member_level==1?'会员':item.UIC_User.member_level==2?'VIP会员':item.UIC_User.member_level==3?'钻石会员':'皇冠会员'}}</a-tag>
														</div>
													</a-popover>
												</a-col>
												<a-col :span="4" style="text-align: center;">
													<span>
														总价：￥ {{order.sku_price*order.amount/100}} <br>
														应付：￥ {{order.receipt_price/100}} <br>
														优惠券满减：￥ -{{order.coupon_derate_fee*order.amount/100}}
													</span>
												</a-col>
												<a-col :span="1" />
												<a-col :span="5" style="text-align: center;color: #0099FF;font-weight: 700;">{{status[order.order_status]}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="3" style="">收件人姓名：{{item.receiver_name}}</a-col>
												<a-col :span="6" style="">收件人手机号码：{{item.receiver_phone}}</a-col>
												<a-col :span="15" style="">地址：{{item.receiver_address}}</a-col>
											</a-row>
											<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													<div>买家备注：</div>
													<span>{{item.remarks}}</span>
												</a-col>
											</a-row>
											<a-row v-if="(item.first_agency_id||item.second_agency_id)&&!(item.profitsharing_info||item.profitsharing_fail_info)"
											 type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													<span>该订单含有代理分账：</span>
													<a-button @click="profitsharingquery(item)">查询</a-button>
												</a-col>

											</a-row>
											<a-row v-if="item.profitsharing_info||item.profitsharing_fail_info" type="flex" justify="start" align="middle"
											 style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="20">
													分账状态提交记录：未提交
												</a-col>
												<a-col :span="4">
													<a-button type="primary" ghost size="small" @click="submitprofitsharing(item)">分账金额无误，提交分账</a-button>
												</a-col>
												<a-col :span="10">
													一级代理分账信息：{{get_first_info(item)}}
												</a-col>
												<a-col :span="10">
													二级代理分账信息：{{get_second_info(item)}}
												</a-col>
												<a-col :span="4">
													<a-button type="danger" ghost size="small" style="color: red;margin-top: 5px;" @click="modifyprofitsharing(item)">分账金额有误，修改提交</a-button>
												</a-col>
											</a-row>
											<a-row v-if="item.profitsharing_fail_info" type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													<span>{{item.profitsharing_fail_info}}</span>
												</a-col>
											</a-row>
											<a-row v-if="item.profitsharing_info" type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px;">
												<a-col :span="24">
													实际分账信息：{{item.profitsharing_info.status}}
												</a-col>
												<a-col :span="8" v-for="(receivers,receiversindex) in item.profitsharing_info.receivers" :key="receiversindex">
													<div v-if="receivers.type == 'MERCHANT_ID'">
														{{receivers.description}},金额￥:{{receivers.amount/100}}
													</div>
													<div v-if="receivers.type == 'PERSONAL_OPENID'">
														账户:{{receivers.user_id}},实际分账金额￥:{{receivers.amount/100}}
													</div>
												</a-col>
											</a-row>

										</div>
									</div>
									<div style="float: right;position: relative;bottom: -18px;">
										<a-pagination showSizeChanger @showSizeChange="onShowSizeChange" :current="endpage/pageSize" :pageSize="pageSize" :total="tradesum"
										 showQuickJumper @change="pageChange" />
									</div>
								</div>
							</a-tab-pane>
						</a-tabs>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>


		<a-modal title="修改分账信息" :visible="modify_visible" @ok="modify_Ok" :confirmLoading="modifyLoading" @cancel="modify_Cancel">
			<div style="">
				<div style="margin: 10px 0;" v-if="modify_info.first_agency_id"><span style="display: inline-block; width: 100px;text-align: right;margin-right: 20px;">一级分账金额</span>
					<a-input-number v-model="modify_info.first_agency_rebate" :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
					 style="width: 250px;" />
				</div>
				<div style="margin: 10px 0;" v-if="modify_info.second_agency_id"><span style="display: inline-block; width: 100px;text-align: right;margin-right: 20px;">二级分账金额</span>
					<a-input-number v-model="modify_info.second_agency_rebate" :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
					 style="width: 250px;" />
				</div>
			</div>
		</a-modal>




	</div>
</template>

<script>
	import moment from 'moment';

	export default {

		data() {
			return {
				current: ['transactionreconciliation'],
				openKeys: ['ordermanagement'],
				liststatus: this.$route.query.liststatus || 'isclear',
				searchlist: {
					sku_title: null,
					trade_id: null,
					receiver_name: null,
					receiver_phone: null,
					start_time: null,
					end_time: null
				},
				dateFormat: 'YYYY-MM-DD',
				tradelist: [],
				status: {
					'to_be_paid': '待付款',
					'have_paid': '待发货',
					'delivery': '已发货',
					'finished': '已完成',
					'success': '交易成功',
					'refund': '退款售后',
					'closed': '已取消',
				},
				tradesum: 0,
				startpage: this.$route.query.startpage || 0,
				endpage: this.$route.query.endpage || 10,
				pageSize: Number(this.$route.query.pageSize) || 10,
				issearch: false,
				modify_info: {
					first_agency_id: null,
					first_agency_rebate: null,
					second_agency_id: null,
					second_agency_rebate: null,
				},
				modify_visible: false,
				modifyLoading: false,
			}
		},
		created: function() {
			if (this.$route.query.searchlist) {
				this.searchlist = JSON.parse(this.$route.query.searchlist);
			}
			this.initialize();
		},
		methods: {
			moment,
			tabChange(activeKey) {

				this.startpage = 0;
				this.endpage = this.pageSize;
				// this.pageSize = 10;
				this.liststatus = activeKey;
				this.$router.push({
					name: 'transactionreconciliation',
					query: {
						startpage: this.startpage,
						endpage: this.endpage,
						pageSize: this.pageSize,
						liststatus: this.liststatus,
						searchlist: JSON.stringify(this.searchlist)
					}
				});
				this.initialize();
			},
			initialize() {
				var self = this;
				this.issearch = true;
				this.tradelist = [];
				this.tradesum = 0;
				var params = {
					searchlist: this.searchlist,
					startpage: this.startpage,
					pageSize: this.pageSize,
					liststatus: this.liststatus,
					apps_id: this.$store.state.now_app_state,
				};
				this.$axios.get('/trade/transactionreconciliation', {
					params: params
				}).then(function(res) {
					for (var i = 0; i < res.data.tradelist.length; i++) {
						res.data.tradelist[i].profitsharing_info = null;
						res.data.tradelist[i].profitsharing_fail_info = null;

					}
					self.tradelist = res.data.tradelist;
					self.tradesum = res.data.counttrade;
					self.issearch = false;

				});
			},
			onShowSizeChange(current, pageSize) {
				this.pageSize = pageSize;
				this.startpage = this.pageSize * (current - 1);
				this.endpage = this.pageSize * current;
				this.initialize();
				this.$router.push({
					name: 'transactionreconciliation',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						liststatus: this.liststatus,
						searchlist: JSON.stringify(this.searchlist)
					}
				})

			},
			pageChange(pageNumber) {
				this.startpage = this.pageSize * (pageNumber - 1);
				this.endpage = this.pageSize * pageNumber;
				this.initialize();

				this.$router.push({
					name: 'transactionreconciliation',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						liststatus: this.liststatus,
						searchlist: JSON.stringify(this.searchlist)
					}
				});
			},
			searchbtn() {
				this.startpage = 0;
				this.endpage = this.pageSize;
				// this.pageSize = 10;
				this.initialize();
				this.$router.push({
					name: 'transactionreconciliation',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						liststatus: this.liststatus,
						searchlist: JSON.stringify(this.searchlist)
					}
				})
			},
			// exportexcel() {
			// 	var self = this;
			// 	var now = this.moment().format('YYYY-MM-DD-HH-mm-ss');
			// 	var params = {
			// 		searchlist: this.searchlist,
			// 		liststatus: this.liststatus
			// 	};
			// 	this.$axios.post('/export/excel', {
			// 		params: params
			// 	}, {
			// 		responseType: 'arraybuffer'
			// 	}).then(function(res) {
			// 		var fileDownload = require('js-file-download');
			// 		fileDownload(res.data, (now + '.xlsx'));
			// 	})

			// },
			onChangeTime(date, dateString) {
				// console.log(dateString)
				this.searchlist.start_time = dateString[0];
				this.searchlist.end_time = dateString[1];
			},
			profitsharingquery(trade) {
				var self = this;
				var params = {
					trade_id: trade.id
				}
				this.$axios.post('/trade/profitsharingquery', {
					params: params
				}).then(function(res) {
					var data = res.data.xml;
					if (data.result_code == "SUCCESS") {
						var profitsharing_info = {
							status: data.status,
							receivers: JSON.parse(data.receivers)
						}
						trade.profitsharing_info = profitsharing_info
						// console.log(trade)
					}
					if (data.result_code == "FAIL") {
						var profitsharing_fail_info = data.err_code_des;
						trade.profitsharing_fail_info = profitsharing_fail_info
					}

				})
			},
			get_first_info(trade) {
				var return_info = ''
				if (!trade.first_agency_id) {
					return_info = "该订单无一级代理";
				} else {
					return_info = "一级代理ID:" + trade.first_agency_id + " 应分金额:￥" + (trade.first_agency_rebate / 100);
				}
				return return_info;
			},
			get_second_info(trade) {
				var return_info = ''
				if (!trade.second_agency_id) {
					return_info = "该订单无二级代理";
				} else {
					return_info = "二级代理ID:" + trade.second_agency_id + " 应分金额:￥" + (trade.second_agency_rebate / 100);
				}
				return return_info;
			},
			submitprofitsharing(item) {
				// console.log(item.id);
				this.modify_info.id = item.id;
				this.modify_info.modify_status = false;
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否确认提交分账状态修改',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/trade/submitprofitsharing', {
							params: self.modify_info
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.modify_visible = false;
							self.modifyLoading = false;
							self.initialize();
						})
					},
					onCancel() {
						self.modifyLoading = false;
					},
				});
			},
			modifyprofitsharing(item) {
				this.modify_info.id = item.id;
				this.modify_info.modify_status = true;
				this.modify_info.first_agency_id = item.first_agency_id;
				this.modify_info.first_agency_rebate = item.first_agency_rebate / 100;
				this.modify_info.second_agency_id = item.second_agency_id;
				this.modify_info.second_agency_rebate = item.second_agency_rebate / 100;
				this.modify_visible = true;
			},
			modify_Cancel() {
				this.modify_visible = false;
				this.modifyLoading = false;
			},
			modify_Ok() {
				this.refundLoading = true;
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否确认提交分账状态修改',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/trade/submitprofitsharing', {
							params: self.modify_info
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.modify_visible = false;
							self.modifyLoading = false;
							self.initialize();
						})
					},
					onCancel() {
						self.modifyLoading = false;
					},
				});
			}

		},

	};
</script>

<style>
	.transactionreconciliation .contentcard {
		padding: 24px 50px;
		background-color: #fff;
		border-radius: 5px;
		margin-bottom: 20px;
		position: relative;
	}

	.transactionreconciliation .card-container {
		overflow: hidden;
	}

	.transactionreconciliation .card-container>.ant-tabs-card>.ant-tabs-content {
		min-height: 120px;
		margin-top: -16px;
	}

	.transactionreconciliation .card-container>.ant-tabs-card>.ant-tabs-content>.ant-tabs-tabpane {
		background: #fff;
		padding: 16px;
	}

	.transactionreconciliation .card-container>.ant-tabs-card>.ant-tabs-bar {
		border-color: #fff;
	}

	.transactionreconciliation .card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
		border-color: transparent;
		background: #ebebee;
		width: 90px;
		text-align: center;
	}

	.transactionreconciliation .card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab-active {
		border-color: #fff;
		background: #fff;
	}

	.transactionreconciliation .ant-steps-dot .ant-steps-item-content {
		width: auto;
	}
</style>



// WEBPACK FOOTER //
// index.vue?4b1931d7